import {css, Theme} from "@emotion/react";
import {Text} from "@pg-design/text";

type MapRegionOptionRowProps = {
    title: string;
    subtitle?: string | null;
    isLast?: boolean;
    onSelect: () => void;
};

export const MapRegionOptionRow = ({title, subtitle, isLast = false, onSelect}: MapRegionOptionRowProps) => (
    <li>
        <button
            type="button"
            css={[rowButton, isLast && rowButtonLast]}
            role="option"
            onMouseDown={(event) => event.preventDefault()}
            onClick={onSelect}
        >
            <span css={textWrapper}>
                <Text variant="body_copy_1" css={titleText} as="span">
                    {title}
                </Text>
                {subtitle ? (
                    <Text variant="info_txt_1" css={subtitleText} as="span">
                        {subtitle}
                    </Text>
                ) : null}
            </span>
        </button>
    </li>
);

export const mapRegionOptionsSection = css`
    padding: 0 0 0.25rem;
`;

export const mapRegionOptionsSectionTitle = css`
    display: block;
    margin: 0 0 1rem;
    padding: 1rem 1.5rem 0;
`;

export const mapRegionOptionsList = css`
    margin: 0;
    padding: 0;
    list-style: none;
`;

const rowButton = (theme: Theme) => css`
    display: flex;
    width: 100%;
    min-height: 4rem;
    padding: 1rem 1.5rem;
    border: none;
    border-bottom: 1px solid ${theme.colors.gray[200]};
    border-radius: 0;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: pointer;

    &:hover,
    &:focus-visible {
        background: ${theme.colors.gray[200]};
        outline: none;
    }
`;

const rowButtonLast = css`
    border-bottom: none;
`;

const textWrapper = css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
`;

const titleText = css`
    text-transform: none;
`;

const subtitleText = (theme: Theme) => css`
    text-transform: none;
    color: ${theme.colors.gray[700]};
`;
